import React, { useState, useEffect, useContext, useRef } from "react";

import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
// import { RadioButton } from "primereact/radiobutton";
// import { InputText } from "primereact/inputtext";
// import { TabView, TabPanel } from "primereact/tabview";
import GlobalContext     from "../../../isp._comun/iu/contexto/GlobalContext";

import Dialogo         from "../../../isp._comun/iu/_principal/componentes/layouts/Dialogo";
import { ModosOp }     from "../../../isp._comun/iu/_principal/constantesIuPrin";
// import EliminarVentana       from "../../../isp._iu.start.principal/reductores/acciones/widgets/EliminarVentana";
// import MostrarVentana        from "../../../isp._comun/iu/_principal/reductores/acciones/widgets/MostrarVentana";
// import PosicionarVentanaTop  from "../../../isp._iu.start.principal/reductores/acciones/widgets/PosicionarVentanaTop";
// import CargarYMostrarVentana from "../../../isp._comun/iu/_principal/reductores/acciones/widgets/CargarYMostrarVentana";


// import VentanaClienteAFacturar from "../../reductores/ventanas/VentanaClienteAFacturar";
import VentanaServicio from "../../reductores/ventanas/VentanaServicio";
import BuscarServicios from "../../reductores/acciones/dispatch/BuscarServicios";

import {TipoItemLabel, UnidadItemLabel } from "./žconstantesIuLayoutServicios";

const DialogoQueryServiciosLayout = ({
    ventana,
    dispatchQ,
    estadoQ,
    buscarItems,
}) => {
    // const { dispatchPrincipal, estadoPrin } = useContext(GlobalContext);

    // const isMounted = useRef(false);

    /*  useEffect(() => {
        if (isMounted.current) {
            buscarClientesAFacturar();
        } else {
            isMounted.current = true;
        }
    }, [estadoQ.flag.sensorDeAccionABuscar]); */

    const { 
        // dispatchPrincipal, 
        // estadoPrin,
        posicionarVentanaTop,
        eliminarVentana,
        cargarYMostrarVentana,
        getVentanaIdenticaSiYaExisteEnLalista,
    } = useContext(GlobalContext);

    useEffect(() => {
        if (estadoQ.flag.procesandoComando) {
            buscarItems.ejecutar({});
        }
        return ()=>{buscarItems.cancelar()};
    }, [estadoQ.flag.procesandoComando]);


    const dobleClickEnFila = (eventoSyn) => {
        const nuevaVentana = new VentanaServicio();
        nuevaVentana.estadoComp.flag.modoOperacion = ModosOp.OK;
        nuevaVentana.estadoComp.domain.screen.idItem = eventoSyn.data.idItem;
        
        const ventanaAAbrir = getVentanaIdenticaSiYaExisteEnLalista(nuevaVentana);
        if (ventanaAAbrir) {
            ventana.ventanaCargando = ventanaAAbrir;
            posicionarVentanaTop(ventanaAAbrir);
            return;
        }
        
        nuevaVentana.estadoComp.flag.modal = true;
        nuevaVentana.estadoComp.flag.cargandoEntidad = true;
        ventana.ventanaCargando = nuevaVentana;
        cargarYMostrarVentana(nuevaVentana);
    };

    const footer = (
        <div>
            <Button
                label={"  Buscar  "}
                icon="pi pi-search"
                onClick={(eventoSynDom) => {
                    dispatchQ(new BuscarServicios());
                    // buscarClientesAFacturar();
                    eventoSynDom.stopPropagation();
                }}
                loading={estadoQ.flag.procesandoComando}
                iconPos="left"
                className="whitespace-pre"
            />
            <Button
                label="Cancelar"
                icon="pi pi-times"
                onClick={(eventoSynDom) => {
                    eliminarVentana(ventana);
                    eventoSynDom.stopPropagation();
                }}
                disabled={estadoQ.flag.procesandoComando}
                // className="w-32"
            />
        </div>
    );

    const header = {
        elementoReact: (
            <p className="p-2 bg-gradient-to-r from-purple-100">Lista de Items</p>
        ),
        enProgreso: false,
        // enProgreso: estadoQ.flag.procesandoComando,
    };

    const tipoItemBodyTemplate=(rowData) => {
        return TipoItemLabel[rowData.tipoItem];
    }

    const unidadBodyTemplate=(rowData) => {
        return UnidadItemLabel[rowData.udm];
    }

    const dialogo = (
        <Dialogo
            // visible={true}
            // // style={{ width: "50vw"}}
            // modal={false}
            // onHide={() => onClick("CERRAR_DIALOGO")}
            // onShow={onShow}
            // onClick={() => onClick("CLICK_PANEL")}
            // keepInViewport={false}
            // maskStyle={{ zIndex: posicionZ }}
            ventana={ventana}
            cabecera={header}
            pie={footer}
            estilo={{ width: "60rem", minHeight: "70vh", top: "15vh", margin: "0" }}
            posicionZ={ventana.posicionZ}
            modal={false}
        >
            <DataTable
                value={estadoQ.data}
                paginator
                rows={8}
                showGridlines
                stripedRows
                size="small"
                selectionMode="single"
                // autoLayout={true}
                // autoLayout
                // autoLayout={false}
                // responsiveLayout="stack"
                // responsiveLayout="scroll"
                scrollable
                scrollDirection="both"
                emptyMessage="No se encontró Items."
                totalRecords={100}
                // columnResizeMode="expand"
                columnResizeMode="fit"
                // resizableColumns
                tableStyle={{ minHeight: "40vh" }}
                onRowDoubleClick={dobleClickEnFila}
            >
                <Column
                    field="idItem"
                    header="Id. Item"
                    style={{ width: "10%" }}
                    // bodyStyle={{ "width": "1%" }}
                    // unstyled
                ></Column>
                <Column
                    field="tipoItem"
                    header="Tipo Item"
                    body={tipoItemBodyTemplate}
                    style={{ width: "14%" }}
                ></Column>
                <Column field="nombre" header="Nombre" style={{ width: "45%" }}></Column>
                <Column field="precio" header="Precio/unit" style={{ width: "12%" }}></Column>
                <Column field="moneda" header="Moneda" style={{ width: "9%" }}></Column>
                
                <Column 
                    field="udm" 
                    header="Unidad"
                    body={unidadBodyTemplate} 
                    style={{ width: "10%" }}
                ></Column>
                {/* <Column field="udm" header="Udm" style={{ width: "25%" }}></Column> */}
                {/* <Column field="dni" header="DNI" style={{ minWidth: "1rem" }}></Column>
                <Column field="ptp" header="PTP" style={{ minWidth: "1rem" }}></Column>
                <Column
                    field="carnetExt"
                    header="C. Extranjería"
                    style={{ minWidth: "1rem" }}
                ></Column>
                <Column field="pasaporte" header="Pasaporte" style={{ minWidth: "1rem" }}></Column> */}
                {/* <Column
                    field="razonSocial"
                    header="Razón Social"
                    style={{ width: "25%" }}
                    unstyled
                ></Column> */}
            </DataTable>
        </Dialogo>
    );

    return dialogo;
};

export default DialogoQueryServiciosLayout;
